 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE_PAGE from '@/components/xhtml/01_Title_Page'
 import XHTML02_COPYRIGHT from '@/components/xhtml/02_Copyright'
 import XHTML03_DEDICATION from '@/components/xhtml/03_Dedication'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_ACKNOWLEDGMENTS from '@/components/xhtml/05_Acknowledgments'
 import XHTML06_PREFACE__WHY_CUBA from '@/components/xhtml/06_Preface__Why_Cuba'
 import XHTML07_INTRODUCTION__IN_PURSUIT_OF_ADEQ from '@/components/xhtml/07_Introduction__In_Pursuit_of_Adeq'
 import XHTML08_1__LA_LUCHA from '@/components/xhtml/08_1__La_Lucha'
 import XHTML09_2__ANTES from '@/components/xhtml/09_2__Antes'
 import XHTML10_3__VIRTUOUS_WOMANHOOD from '@/components/xhtml/10_3__Virtuous_Womanhood'
 import XHTML11_4__COMMUNITY from '@/components/xhtml/11_4__Community'
 import XHTML12_5__BREAKDOWN from '@/components/xhtml/12_5__Breakdown'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML13_CONCLUSION__THE_POLITICS_OF_ADEQ from '@/components/xhtml/13_Conclusion__The_Politics_of_Adeq'
 import XHTML14_NOTES from '@/components/xhtml/14_Notes'
 import XHTML15_REFERENCES from '@/components/xhtml/15_References'
 import XHTML16_INDEX from '@/components/xhtml/16_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Acknowledgments",
 			"name" : "xhtml/05_Acknowledgments",
 			"component" : XHTML05_ACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/06_Preface__Why_Cuba",
 			"name" : "xhtml/06_Preface__Why_Cuba",
 			"component" : XHTML06_PREFACE__WHY_CUBA
 		},
 		{
 			"path" : "/xhtml/07_Introduction__In_Pursuit_of_Adeq",
 			"name" : "xhtml/07_Introduction__In_Pursuit_of_Adeq",
 			"component" : XHTML07_INTRODUCTION__IN_PURSUIT_OF_ADEQ
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js